import { render, staticRenderFns } from "./ColumnSort.vue?vue&type=template&id=6fef2a35&scoped=true"
import script from "./ColumnSort.vue?vue&type=script&lang=ts"
export * from "./ColumnSort.vue?vue&type=script&lang=ts"
import style0 from "./ColumnSort.vue?vue&type=style&index=0&id=6fef2a35&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fef2a35",
  null
  
)

export default component.exports